import { MetafyPartnerEnum } from '$lib/types/api/graphql';

export const PLANS = {
  [MetafyPartnerEnum.Core]: {
    comingSoon: false,
    title: 'Core',
    description: 'Everything you need to get started—no monthly fees, only pay 8% on what you earn!',
    monthly: 0,
    yearly: 0,
    percentage: 8,
    features: [
      ['Sell free & paid Sessions', 'Replaces Fiverr, Calendly'],
      ['Sell free & paid Events', 'Replaces Outschool, Eventbrite'],
      ['Sell free & paid Guides', 'Replaces Kajabi, Udemy'],
      ['Create free & paid Groups', 'Replaces Patreon, Discord, Facebook']
    ],
    example: {
      title: "You're just starting your side hustle",
      description: 'No monthly fees, simply pay as you earn with a convenient revenue share model.'
    }
  },
  [MetafyPartnerEnum.Pro]: {
    comingSoon: false,
    title: 'Pro',
    description: 'Unlock your full earning potential. Grow with a fixed monthly cost!',
    monthly: 29,
    yearly: 19,
    percentage: 0,
    features: [['Keep everything you earn, no additional fees']],
    example: {
      title: '100% sounds better than 92%',
      description: 'Your success, your money - all of it. Maximize your income, minimize your costs.'
    }
  }
  // [MetafyPartnerEnum.Ultra]: {
  //   comingSoon: true,
  //   title: 'Ultra',
  //   description: 'Coming Soon - Even more power with Classes on platform!',
  //   monthly: 149,
  //   yearly: 119,
  //   percentage: 0,
  //   features: [['Sell paid Classes', 'Replaces Kajabi, Teachable, Maven']],
  //   example: {
  //     title: 'You pay $99 a month, and nothing more, no matter how much you earn',
  //     description: 'If you earn $200 a month, you’ll pay $99 plus applicable taxes'
  //   }
  // }
};
